import Banner from 'common/components/banner'
import Button from 'common/components/button'
import { Alert } from 'common/icons'

type Props = {
  variantsToBeApprovedCount: number
  onClick: () => void
}

const NewVariantsBanner = ({ variantsToBeApprovedCount, onClick }: Props) => {
  return (
    <Banner
      type="error"
      cta={
        <Button variant="link" onClick={onClick} tone="light">
          Show me
        </Button>
      }
      icon={
        <Alert
          size={4}
          className="text-white"
          state="default"
          isDefaultColor={false}
        />
      }
      text={
        variantsToBeApprovedCount > 1
          ? `There are ${variantsToBeApprovedCount} new variants that need your approval.`
          : `There is ${variantsToBeApprovedCount} new variant that needs your approval.`
      }
    />
  )
}

export default NewVariantsBanner
